import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subdivision } from 'src/shared/api';

@Component({
	selector: 'rpshared-subdivision-dialog',
	templateUrl: './subdivision-dialog.component.html',
	styleUrls: ['./subdivision-dialog.component.css'],
})
export class SubdivisionDialogComponent implements OnInit {
	control = new FormControl('') as FormControl;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		private readonly subdivision: Subdivision
	) {}

	ngOnInit() {
		if (this.subdivision) {
			this.control.setValue(this.subdivision);
		}
	}
}
